global.maskedInputInit = function() {
  jQuery('.masked-ssn').mask('000-00-0000');
  jQuery('.masked-phone').mask('(000) 000-0000');
  jQuery('.masked-money').mask('#,###.00', { reverse: true });
};

$(document).on('turbolinks:load', maskedInputInit);
